import "./plak.scss"
function Plak({id}) {
  return (
    <div className="plak">
      <div className="plak-ir">IR</div>
      <div className="plak-id">{id}</div>
    </div>
  );
}

export default Plak;
